import type { toggleVariants } from '@/components/ui/toggle';
import { LinkSlashIcon } from '@heroicons/react/16/solid';
import type { Editor } from '@tiptap/react';
import type { VariantProps } from 'class-variance-authority';
import * as React from 'react';
import type { FormatAction } from '../../types';
import { LinkEditPopover } from '../link/link-edit-popover';
import { ToolbarSection } from '../toolbar-section';

interface LinkSectionAction extends FormatAction {
  value: 'unsetLink';
}

interface LinkSectionProps extends VariantProps<typeof toggleVariants> {
  editor: Editor;
}

const hasSelectedLink = (editor: Editor): boolean => {
  const { from, to } = editor.state.selection;
  if (from === to) {
    return false;
  }

  let isLinkSelected = false;
  editor.state.doc.nodesBetween(from, to, (node) => {
    if (node.marks.some((mark) => mark.type.name === 'link')) {
      isLinkSelected = true;
      return false;
    }

    return true;
  });

  return isLinkSelected;
};

export const LinkSection: React.FC<LinkSectionProps> = ({
  editor,
  size,
  variant,
}) => {
  const linkActions = React.useMemo<LinkSectionAction[]>(
    () => [
      {
        value: 'unsetLink',
        label: 'Ta bort länk',
        icon: <LinkSlashIcon className='size-5' />,
        action: (currentEditor) => {
          currentEditor.chain().focus().unsetLink().run();
        },
        isActive: () => false,
        canExecute: (currentEditor) =>
          hasSelectedLink(currentEditor) &&
          currentEditor.can().chain().focus().unsetLink().run(),
      },
    ],
    []
  );

  return (
    <>
      <LinkEditPopover editor={editor} size={size} variant={variant} />
      <ToolbarSection
        editor={editor}
        actions={linkActions}
        mainActionCount={1}
        size={size}
        variant={variant}
      />
    </>
  );
};
